import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Header from '../common/Header';
import Footer from '../common/Footer';
import cssObj from '../../assets/css/cssObj';

const Container = styled.div`
    display: grid;
    grid-template: 1fr / 1fr;
    margin: 0 auto;

    @media (min-width: ${cssObj.vars.xLargeBreakPoint}) {
        grid-template: auto auto / ${cssObj.vars.verticalHeaderWidth} 1fr;
    }
`;

const Main = styled.main`
    background-color: #ffffff;
    min-height: calc(100vh - 3rem);
    padding: 10rem 1rem 5rem 1rem;

    > .tl-edges {
        overflow: visible;
    }

    @media (min-width: ${cssObj.vars.smallBreakPoint}) {
        padding: 10rem 2rem 5rem 2rem;
    }

    @media (min-width: ${cssObj.vars.xLargeBreakPoint}) {
        grid-column-start: 2;
        padding-top: 2rem;
    }
`;

const Layout = ({ children }) => {
    return (
        <Container>
            <Header />
            <Main>{children}</Main>
            <Footer />
        </Container>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired
};

export default Layout;
